import React from 'react';
import { Helmet } from 'react-helmet';

/**
 * Componente Head global para incluir los favicons y otras etiquetas meta comunes
 * Este componente debe incluirse en el layout principal de la aplicación
 */
export default function Head() {
  return (
    <Helmet>
      {/* Favicons */}
      <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
      <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
      <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
      <link rel="manifest" href="/site.webmanifest" />
      <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#FCAA0D" />
      <meta name="msapplication-TileColor" content="#FCAA0D" />
      <meta name="theme-color" content="#FCAA0D" />

      {/* Metadatos básicos */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="Spanish" />
      <meta name="author" content="Innotec Food Equipment" />

      {/* Preconectar a dominios externos */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://jlufgkgssnxumguvknhc.supabase.co" />
    </Helmet>
  );
}
